import { keys } from '../../Constants/constants';
import { KeyboardContainer } from './styles';

interface Props {
  handleKeyPress: (key: string) => void;
}

const Keyboard = ({ handleKeyPress }: Props) => {
  return (
    <KeyboardContainer>
      {keys.map((item, index) => (
        <div key={index}>
          {item.map((key, keyIndex) => (
            <button
              key={keyIndex}
              onClick={() => {
                handleKeyPress(key);
              }}
            >
              {key}
            </button>
          ))}
        </div>
      ))}
    </KeyboardContainer>
  );
};

export default Keyboard;
